<template>
  <main class="app-container">
    <div class="leader-show" v-if="leader.id">
      <div class="info ch-flex">
        <div class="avatar">
          <img :src="leader.avatar" alt="">
        </div>
        <div class="text .ch-flex__item">
          <h4>{{leader.name}}</h4>
          <p>带领课程：{{leader.courses_count}} 次</p>
          <p>加入时间：{{leader.created_at}}</p>
        </div>
      </div>


      <div class="p10">
        <md-tabs @change="tabChange">
          <md-tab-pane class="content" name="about" label="关于我">
            {{leader.content}}
          </md-tab-pane>
          <md-tab-pane class="content" name="courses" label="我的课程">
            <list-loading v-show="loading" />
            <div class="no-result" v-show="!loading && courses.length < 1">暂无数据</div>
            <CourseItem
                    v-for="item in courses"
                    :key="item.id"
                    :course="item"
                    :hide-leader="true"
            />
          </md-tab-pane>
        </md-tabs>
      </div>
    </div>
  </main>
</template>

<script>
    import {Tabs, TabPane} from 'mand-mobile'
    import CourseItem from "../components/CourseItem.vue";
    import ListLoading from "../components/ListLoading.vue";

export default {
  name: "leader-show",
    data() {
        return {
            loading:true,
            leader:{id:null},
            courses:[],
        }
    },
  components: {
      CourseItem,ListLoading,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
  },
    created() {
      const {id} = this.$route.params;
      if(id) {
          this.loadData(id);
      }
    },

    methods: {
        loadData(id) {
            this.$toast.loading("加载中...");
            this.$http.get(`leaders/${id}`)
                .then(({data}) => {
                    this.$toast.hide();
                    this.leader = data;
                    console.log(data);
                    this.loadCourses(id);
                });
        },
        loadCourses(leaderId) {
            this.$http.get('courses', {params:{leader_id:leaderId,show_expired:1}})
                .then(({data}) => {
                    this.loading = false;
                    this.courses = data;
                });
        },
        tabChange(tab) {
          if(tab.label == 'courses' && this.leader.id)
              this.loadCourses(this.leader.id);
        },
    }
};
</script>


<style lang="scss" scoped>
  .leader-show {
    .content{
      padding: 30px 0;
      font-size:28px;
      line-height: 1.5;
    }

    .info {
      padding: 60px 30px;
      background: #fff;
      .avatar {
        width: 250px;

        img {
          width: 200px;
          height: 200px;
          border-radius: 50%;
        }
      }

      .text {
        h4 {
          font-size: 32px;
          font-weight:500;
          margin-bottom:20px;
          margin-top:30px;
        }

        p {
          font-size:28px;
          margin-top:10px;
          color: #9f9f9f;
        }
      }
    }
  }

</style>
<style>
  .leader-show .md-tab-bar{
    background-color: transparent !important;
    border-bottom: 1px solid #ddd;
  }
</style>
